import { SVGProps, Ref, forwardRef } from 'react';

export const CalendarOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.6 3.299C2.034 4.027 1.079 6.349 1 13c.103 8.721 1.714 10 11 10s10.897-1.279 11-10c-.079-6.65-1.034-8.973-5.6-9.701V1h-1.8v2.101A52 52 0 0 0 12 3c-1.358 0-2.551.027-3.6.101V1H6.6zm0 1.826V7h1.8V4.906C9.405 4.83 10.591 4.8 12 4.8s2.595.03 3.6.106V7h1.8V5.125c1.229.226 1.913.561 2.344.946.423.379.787.973 1.046 2.092q.099.428.172.937H3.039q.072-.509.171-.937c.259-1.12.623-1.713 1.046-2.092.43-.385 1.115-.72 2.344-.946M2.868 10.9A47 47 0 0 0 2.8 13c.026 2.144.146 3.692.41 4.837.259 1.12.623 1.713 1.046 2.092.441.394 1.148.736 2.434.962 1.294.228 3.004.309 5.31.309s4.016-.081 5.31-.309c1.286-.226 1.993-.568 2.434-.962.423-.379.787-.973 1.046-2.092.264-1.145.384-2.693.41-4.837a47 47 0 0 0-.067-2.1z"
                fill="currentColor"
            />
        </g>
    </svg>
));
CalendarOutlinedSize24Glyph.displayName = 'CalendarOutlinedSize24Glyph';
